import React from "react"
import { makeStyles, InputLabel, TextField } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    label: {
        marginBottom: '12px'
        }
}));

export default function InputDatepicker(props) {
    const classes = useStyles();


    return(
        <>
            <div>
                <TextField
                type="date"
                fullWidth
                id={props.id}    
                label={props.label}      
                value={props.value}
                onChange={(e) => {props.onChange(e.target.value)}}
                variant="outlined"
                disabled={props.disabled}
                error={props.hasError}
                helperText={props.errorText}
                InputLabelProps={{ shrink: true }}
            />
            </div>
        </>
    )
}